import { ZodError } from 'zod';

import type { VanityLinkErrorCode } from '../constants';
import { VANITY_ERROR_MAP, vanityLinkErrorCodes } from '../constants';

export function parseError(error: unknown): VanityLinkErrorCode[] {
	if (error instanceof ZodError) return error.format()._errors as VanityLinkErrorCode[];
	const err = error instanceof Error ? error.message : undefined;
	return [vanityLinkErrorCodes.find((val: VanityLinkErrorCode) => val === err) ?? VANITY_ERROR_MAP.GENERIC_ERROR.code];
}
